import { type ReactNode } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import { CloseIcon } from "./icons";
import { useHeader } from "./header.context";

interface MobileMenuProps {
  children: Readonly<ReactNode>;
}

export default function MobileMenu({ children }: MobileMenuProps) {
  const { burger, setBurger } = useHeader();

  if (burger) {
    return (
      <motion.div
        initial={{ opacity: 0, x: "-100%" }}
     animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: "-100%"}}
      transition={{ type: "spring", damping: 30, stiffness: 300 }}
        onClick={() => setBurger(false)}
        className="fixed inset-0 z-40 bg-black/70 px-18 py-8 backdrop-blur-xl"
      >
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.2 }}
          className="flex w-full flex-col items-stretch gap-2 p-6 md:hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-end">
            <button
              className="btn btn-soft border-none bg-transparent"
              onClick={() => setBurger(false)}
            >
              <CloseIcon />
            </button>
          </div>
          {children}
        </motion.div>
      </motion.div>
    );
  }
  return <></>;
}

interface MobileMenuItemProps {
  link: string;
  label: string;
}

export function MobileMenuItem({ link, label }: MobileMenuItemProps) {
  const { setBurger } = useHeader();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setTimeout(() => {
      setBurger(false);
    }, 300);
  };

  return (
    <Link
      onClick={handleClick}
      className="rounded-xl px-4 py-3 text-center text-lg hover:bg-slate-800/60"
      href={link}
    >
      {label}
    </Link>
  );
}
